module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gPageBorder",
    attrs: {
      "id": ""
    }
  }, [_c('el-form', {
    ref: "firm",
    staticClass: "gForm",
    attrs: {
      "label-position": "right",
      "rules": _vm.rules,
      "label-width": "12.5%",
      "model": _vm.firm
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_firm'),
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.firm.name),
      callback: function($$v) {
        _vm.$set(_vm.firm, "name", $$v)
      },
      expression: "firm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_contact'),
      "prop": "contact"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.firm.contact),
      callback: function($$v) {
        _vm.$set(_vm.firm, "contact", $$v)
      },
      expression: "firm.contact"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_contactPhone'),
      "prop": "tel"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.firm.tel),
      callback: function($$v) {
        _vm.$set(_vm.firm, "tel", $$v)
      },
      expression: "firm.tel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_addres'),
      "prop": "addr"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.firm.addr),
      callback: function($$v) {
        _vm.$set(_vm.firm, "addr", $$v)
      },
      expression: "firm.addr"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.save('firm')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_save')))])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ef79250"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/data/newFirm.vue
// module id = 967
// module chunks = 0